import React, { useEffect, useMemo, useState } from 'react';
import classnames from 'classnames/bind';
import { useLocalStore, useObserver } from 'mobx-react';
import Avatar from '@/components/PC/Avatar';
import Style from './index.less';
import { RecordMessage } from '@/types/record';
import clientModels from '@/client/models';
import { durationTime } from '@/utils/common';
import { meeting as meetingModel } from '@/models';

const $c = classnames.bind(Style);

function insertBr(text = ''): string {
  return text.replace(/\n/g, '<br/>');
}

interface TranscribeItemPros {
  msg: RecordMessage;
  preMsg: RecordMessage | undefined;
  className?: string;
}
const TranscribeItem: React.FC<TranscribeItemPros> = function (props: TranscribeItemPros) {
  const { msg, preMsg, ...otherProps } = props;
  const meeting = useLocalStore(() => meetingModel);

  const [userInfo, setUserInfo] = useState<null | defs.client.ParticipatorInformationV3>();

  const startTime = useMemo(() => {
    return new Date(meeting.info?.beginTime || 0).getTime();
  }, [meeting.info?.beginTime]);

  // 会议持续时间展示
  const time = useMemo(() => {
    if (!startTime) return '00:00';
    return durationTime(msg.timestamp, startTime);
  }, [startTime, msg.timestamp]);

  const needHeader = useMemo(() => {
    const minute = 1000 * 60;
    return !(
      msg.yxuid === preMsg?.yxuid &&
      Math.floor((msg.timestamp - startTime) / minute) ===
        Math.floor((preMsg?.timestamp - startTime) / minute)
    );
  }, [msg.timestamp, preMsg?.timestamp, startTime]);

  useEffect(() => {
    const member = meeting?.getMemberByYxuid(`${msg.yxuid}`);
    setUserInfo({
      memberName: member?.memberName,
      memberAvatarUrl: '',
    });
  }, []);

  return useObserver(() => {
    return (
      <div
        {...otherProps}
        key={msg.id}
        // className={$c('msg-item', { 'msg-my': msg.flow === 'out' })}
        data-msgid={msg.id}
        className={classnames(
          $c('msg-item', { 'no-header': !needHeader, 'is-first': !preMsg }),
          otherProps.className || ''
        )}
      >
        <div className={$c('msg-left')}>
          {needHeader && <Avatar size={28} type="cover" name={msg?.name || userInfo?.memberName} />}
        </div>
        <div className={$c('msg-right')}>
          {needHeader && (
            <div className={$c('msg-header')}>
              <span className={$c('nick-name')}>
                {userInfo?.memberName || msg.name || '&nbsp;'}
              </span>
              <span className={$c('msg-time')}>{time}</span>
            </div>
          )}
          <div className={$c('msg-content', { 'is-temp': msg.sentenceType === 2 })}>
            <span dangerouslySetInnerHTML={{ __html: insertBr(msg.subtitleContent) }} />
          </div>
        </div>
      </div>
    );
  });
};

export default TranscribeItem;
